import { render } from "./couponStatistics.vue?vue&type=template&id=303dc27d&ts=true"
import script from "./couponStatistics.vue?vue&type=script&lang=ts"
export * from "./couponStatistics.vue?vue&type=script&lang=ts"

import "./couponStatistics.vue?vue&type=style&index=0&id=303dc27d&lang=css"

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__